<template>
  <div>
      <SaleDetail title="Sales Invoice" type="SI"></SaleDetail>
  </div>
</template>

<script>
import SaleDetail from './details.vue'
export default {
  components: { SaleDetail },
}
</script>